<script setup lang="ts">
withDefaults(
  defineProps<{
    darkTheme?: boolean
  }>(),
  {
    darkTheme: false,
  },
)
</script>
<template>
  <div class="arrow-scroll__container">
    <div
      :class="[
        'arrow-scroll',
        { 'border-gray-700': darkTheme, 'border-white': !darkTheme },
      ]"
    />
  </div>
</template>

<style scoped>
.arrow-scroll__container {
  width: 20rem;
  height: 6rem;
  @apply cursor-pointer;
}

@screen md {
  .arrow-scroll__container {
    height: 8rem;
  }
}

.arrow-scroll {
  width: 2rem;
  height: 2rem;
  border-width: 2px;
  border-style: solid;
  border-left: 0;
  border-top: 0;
  transform: rotate(45deg);
  animation: going-south 2s infinite;
  @apply inline-block relative top-1/2 opacity-100;
}

@keyframes going-south {
  0% {
    transform: translate(0, -50px) rotate(45deg);
    @apply opacity-0;
  }
  50% {
    @apply opacity-100;
  }
  100% {
    transform: translate(0, -10px) rotate(45deg);
    @apply opacity-0;
  }
}
</style>
